import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import newHome from './views/Newhome.vue'

Vue.use(Router);

export default new Router({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes: [{
			path: '/',
			name: 'home',
			component: newHome,
			meta: {
				keepAlive: true // 缓存
			}
		},
		// {
		//     path: '/home',
		//     name: 'home',
		//     component: Home,
		//     meta: {
		//         keepAlive: true // 缓存
		//     }
		// },
		
		{
			//注册时隐私条款
			path: '/a/shop2980',
			name: 'shop2980',
			component: () => import('./views/activity/shop2980.vue')
		},
		{
			//用户搜索二级页
			path: '/search',
			name: 'search',
			component: () => import('./views/Search.vue')
		},
		{
			// 主页-新
			path: '/newhome',
			name: 'newhome',
			component: () => import('./views/Newhome.vue')
		},
		{
			//用户注册
			path: '/userRegister',
			name: 'userRegister',
			component: () => import('./views/UserRegister.vue')
		},
		{
			//用户登录
			path: '/userLogin',
			name: 'userLogin',
			component: () => import('./views/UserLogin.vue')
		},
		{
			//用户支付宝登录
			path: '/userLoginAlipay',
			name: 'userLoginAlipay',
			component: () => import('./views/UserLoginAlipay.vue')
		},
		{
			//用户忘记密码
			path: '/userRetrievePass',
			name: 'userRetrievePass',
			component: () => import('./views/UserRetrievePass.vue')
		},
		{
			//用户个人中心
			path: '/nows/:id',
			name: 'nows',
			component: () => import('./views/Nows.vue'),

		},
		{
			//用户会员卡列表
			path: '/userCardList',
			name: 'userCardList',
			component: () => import('./views/UserCardList.vue')
		},
		{
			//用户会员卡列表
			path: '/userCardList',
			name: 'userCardList',
			component: () => import('./views/UserCardList.vue')
		},
		{
			//用户会员卡详情
			path: '/userCardDetails/:shopId',
			name: 'userCardDetails',
			component: () => import('./views/UserCardDetails.vue')
		},
		{
			//用户兑换记录
			path: '/userExchangeList',
			name: 'userExchangeList',
			component: () => import('./views/UserExchangeList.vue')
		},
		{
			//用户消费记录
			path: '/userConsumeList',
			name: 'userConsumeList',
			component: () => import('./views/UserConsumeList.vue')
		},
		{
			//用户提问
			path: '/userAnswer',
			name: 'userAnswer',
			component: () => import('./views/UserAnswer.vue')
		},
		{
			//用户分享
			path: '/userShare',
			name: 'userShare',
			component: () => import('./views/UserShare.vue')
		},
		{
			//用户分享列表
			path: '/userShareList',
			name: 'userShareList',
			component: () => import('./views/UserShareList.vue')
		},
		{
			//用户分享所获得的商品
			path: '/userShareExchange',
			name: 'userShareExchange',
			component: () => import('./views/UserShareExchange.vue')
		},
		{
			//分享商品详情
			path: '/userShareGoodsDetails/:goodsId',
			name: 'userShareGoodsDetails',
			component: () => import('./views/UserShareGoodsDetails.vue')
		},
		{
			//分享商品订单
			path: '/userShareGoodsOrder/:param',
			name: 'userShareGoodsOrder',
			component: () => import('./views/UserShareGoodsOrder.vue')
		},
		{
			//分享商品订单详情
			path: '/userShareExchangeDetails/:orderId',
			name: 'userShareExchangeDetails',
			component: () => import('./views/UserShareExchangeDetails.vue')
		},
		{
			//用户签到
			path: '/userSignIn',
			name: 'userSignIn',
			component: () => import('./views/UserSignIn.vue')
		},
		{
			//用户签到历史
			path: '/userSignInHistory',
			name: 'userSignInHistory',
			component: () => import('./views/UserSignInHistory.vue')
		},
		{
			//用户待领红包记录
			path: '/userWaitingList',
			name: 'userWaitingList',
			component: () => import('./views/UserWaitingList.vue')
		},
		{
			//用户新增收货地址
			path: '/userAddressAdd',
			name: 'userAddressAdd',
			component: () => import('./views/UserAddressAdd.vue')
		},
		{
			//用户编辑收货地址
			path: '/userAddressChange/:addressId',
			name: 'userAddressChange',
			component: () => import('./views/UserAddressChange.vue')
		},
		{
			//用户收货地址列表
			path: '/userAddressList/:addressId',
			name: 'userAddressList',
			component: () => import('./views/UserAddressList.vue')
		},
		{
			//用户订单列表
			path: '/userOrderList',
			name: 'userOrderList',
			component: () => import('./views/UserOrderList.vue')
		},
		{
			//用户订单详情
			path: '/userOrderDetails/:orderId',
			name: 'userOrderDetails',
			component: () => import('./views/UserOrderDetails.vue')
		},
		{
			//用户提现到微信
			path: '/userTX/:balance',
			name: 'userTX',
			component: () => import('./views/UserTX.vue')
		},
		{
			//用户提现到支付宝
			path: '/userTXByAlipay/:balance',
			name: 'userTXByAlipay',
			component: () => import('./views/UserTXByAlipay.vue')
		},
		{
			//用户提现记录
			path: '/userTXList',
			name: 'userTXList',
			component: () => import('./views/UserTXList.vue')
		},
		{
			//用户修改提现密码
			path: '/userRetrievePayPass/:balance',
			name: 'userRetrievePayPass',
			component: () => import('./views/UserRetrievePayPass.vue')
		},
		{
			//购物车
			path: '/cart',
			name: 'cart',
			component: () => import('./views/user/Cart.vue')
		},
		{
			//附近商家
			path: '/nearbyShop',
			name: 'nearbyShop',
			component: () => import('./views/NearbyShop.vue')
		},
		{
			//附近商家
			path: '/shopDetails/:shopId/:distance',
			name: 'shopDetails',
			component: () => import('./views/ShopDetails.vue')
		},
		{
			//附近商家
			path: '/newshopdetail/:shopId/:distance',
			name: 'newshopdetail',
			component: () => import('./views/shop/newshopdetail.vue')
		},
		{
			//附近商家 - 服务详情
			path: '/newshopgoodsdetail/:shopId/:id',
			name: 'newshopgoodsdetail',
			component: () => import('./views/shop/newshopgoodsdetail.vue')
		},
		{
			//商家兑换产品详情
			path: '/shopexchangedetail/:shopId/:id',
			name: 'shopexchangedetail',
			component: () => import('./views/newviews/shopexchangedetail.vue')
		},
		{
			//领货点
			path: '/receiveShopList',
			name: 'receiveShopList',
			component: () => import('./views/ReceiveShopList.vue')
		},
		{
			//红包送人
			path: '/Hbtouser',
			name: 'Hbtouser',
			component: () => import('./views/user/Hbtouser.vue')
		},
		{
			//用户分享
			path: '/shareuser',
			name: 'shareuser',
			component: () => import('./views/shareuser.vue')
		},
		{
			//我的分享
			path: '/myshareuser',
			name: 'myshareuser',
			component: () => import('./views/myshareuser.vue')
		},
		{
			//用户分享
			path: '/shareusermoney',
			name: 'shareusermoney',
			component: () => import('./views/shareusermoney.vue')
		},
		{
			//领货点详情
			path: '/receiveShopDetail/:shopId/:distance',
			name: 'receiveShopDetail',
			component: () => import('./views/ReceiveShopDetail.vue')
		},
		{
			//企业服务
			path: '/qyfw',
			name: 'qyfw',
			component: () => import('./views/Qyfw.vue')
		},
		{
			//用户红包获取记录
			path: '/userredlist',
			name: 'userredlist',
			component: () => import('./views/userredlist.vue')
		},
		{
			//用户红包消费记录
			path: '/userreduselist',
			name: 'userreduselist',
			component: () => import('./views/userreduselist.vue')
		},
		{
			//用户扫码付款记录
			path: '/userpaylist',
			name: 'userpaylist',
			component: () => import('./views/userpaylist.vue')
		},
		{
			//领货点详情
			path: '/qyfwcate/:shopId/:distance',
			name: 'qyfwcate',
			component: () => import('./views/Qyfwcate.vue')
		},
		{
			//支付
			path: '/pay',
			name: 'pay',
			component: () => import('./views/Pay.vue')
		},
		{
			//微信支付测试
			path: '/pay1',
			name: 'pay1',
			component: () => import('./views/Pay1.vue')
		},
		{
			//支付宝支付
			path: '/payAlipay/:shopId',
			name: 'payAlipay',
			component: () => import('./views/PayAlipay.vue')
		},
		{
			//支付宝支付测试
			path: '/payAlipay1/:shopId',
			name: 'payAlipay1',
			component: () => import('./views/PayAlipay1.vue')
		},
		{
			//支付宝支付成功后界面
			path: '/payAlipaySuccess',
			name: 'payAlipaySuccess',
			component: () => import('./views/PayAlipaySuccess.vue')
		},
		{
			//商家登录
			path: '/shopLogin',
			name: 'shopLogin',
			component: () => import('./views/ShopLogin.vue')
		},
		{
			//商家入驻
			path: '/shopRegister',
			name: 'shopRegister',
			component: () => import('./views/ShopRegister.vue')
		},
		{
			//商家找回登录密码
			path: '/shopRetrievePass',
			name: 'shopRetrievePass',
			component: () => import('./views/ShopRetrievePass.vue')
		},
		{
			//商家找回支付密码
			path: '/shopRetrievePayPass/:balance',
			name: 'shopRetrievePayPass',
			component: () => import('./views/ShopRetrievePayPass.vue')
		},
		{
			//商家提现到微信
			path: '/shopTX/:balance',
			name: 'shopTX',
			component: () => import('./views/ShopTX.vue')
		},
		{
			//商家提现到支付宝
			path: '/shopTXByAlipay/:balance',
			name: 'shopTXByAlipay',
			component: () => import('./views/ShopTXByAlipay.vue')
		},
		{
			//商家数据统计
			path: '/shopStatistics',
			name: 'shopStatistics',
			component: () => import('./views/ShopStatistics.vue')
		},
		{
			//商家活动
			path: '/shopactivity',
			name: 'shopactivity',
			component: () => import('./views/shopactivity.vue')
		},
		{
			//商家活动详情
			path: '/shopActivityDetails/:shopId',
			name: 'shopActivityDetails',
			component: () => import('./views/shopActivityDetails.vue')
		},
		{
			//商家个人中心
			path: '/shopInfo',
			name: 'shopInfo',
			meta: {
				requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
			},
			component: () => import('./views/ShopInfo.vue')
		},
		{
			//商家收款记录
			path: '/shopConsumeList',
			name: 'shopConsumeList',
			meta: {
				requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
			},
			component: () => import('./views/ShopConsumeList.vue')
		},
		{
			//商家流水
			path: '/shopFlowing',
			name: 'shopFlowing',
			meta: {
				requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
			},
			component: () => import('./views/ShopFlowing.vue')
		},
		{
			//商家提现记录
			path: '/shopCashList',
			name: 'shopCashList',
			meta: {
				requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
			},
			component: () => import('./views/ShopCashList.vue')
		},
		{
			//商家兑换记录
			path: '/shopExchangeList',
			name: 'shopExchangeList',
			meta: {
				requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
			},
			component: () => import('./views/ShopExchangeList.vue')
		},
		{
			//商家锁客记录
			path: '/shopLockGuestList',
			name: 'shopLockGuestList',
			meta: {
				requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
			},
			component: () => import('./views/ShopLockGuestList.vue')
		},
		{
			//商家锁客记录
			path: '/shopLockGuestTCList',
			name: 'shopLockGuestTCList',
			meta: {
				requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
			},
			component: () => import('./views/ShopLockGuestTCList.vue')
		},
		{
			//商家合作
			path: '/shopCooperation',
			name: 'shopCooperation',
			meta: {
				requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
			},
			component: () => import('./views/ShopCooperation.vue')
		},
		{
			//商家合作
			path: '/shopxqfk',
			name: 'shopxqfk',
			component: () => import('./views/Shopxqfk.vue')
		},
		{
			//商家特色商品列表
			path: '/myShopGoodsList',
			name: 'myShopGoodsList',
			component: () => import('./views/shop/myShopGoodsList')
		},
		{
			//商家介绍
			path: '/introduce',
			name: 'introduce',
			component: () => import('./views/shop/Introduce')
		},
		{
			//商家积分朋友圈模块
			path: '/shopScore',
			name: 'shopScore',
			component: () => import('./views/shop/shopScore')
		},
		{
			//商家积分朋友圈模块
			path: '/exchangeWechat',
			name: 'exchangeWechat',
			component: () => import('./views/shop/exchangeWechat')
		},
		{
			//我得兑换
			path: '/myWechats',
			name: 'myWechats',
			component: () => import('./views/shop/myWechats')
		},
		{
			//我得兑换内层
			path: '/myWechatsIn',
			name: 'myWechatsIn',
			component: () => import('./views/shop/myWechatsIn')
		},
		{
			//商家介绍
			path: '/shopaddvideo',
			name: 'shopaddvideo',
			component: () => import('./views/shop/Shopaddvideo')
		},
		{
			//商家上传视频广场视频
			path: '/shopaddvideolive',
			name: 'shopaddvideolive',
			component: () => import('./views/shop/Shopaddvideolive')
		},
		{
			//商家的视频
			path: '/myshopvideo',
			name: 'myshopvideo',
			component: () => import('./views/shop/myshopvideo')
		},
		{
			//商品列表
			path: '/goodsList',
			name: 'goodsList',
			component: () => import('./views/GoodsList.vue')
		},
		{
			//商品集合
			path: '/goodsMuster/:typeId/:searchKey',
			name: 'goodsMuster',
			component: () => import('./views/GoodsMuster.vue'),
			// meta: {
			//     keepAlive: true // 缓存
			// }
		},
		{
			//特价商品
			path: '/offer/:typeId',
			name: 'offer',
			component: () => import('./views/Offer.vue'),
			// meta: {
			//     keepAlive: true // 缓存
			// }
		},
		//-------------------------------------
		{
			//我的个人信息
			path: '/userInfo',
			name: 'userInfo',
			component: () => import('./views/UserInfo.vue')
		},
		{
			//我的订单
			path: '/orderList',
			name: 'orderList',
			component: () => import('./views/user/OrderList.vue'),
			// meta: {
			//     keepAlive: true // 缓存
			// }
		},
		{
			//订单详情
			path: '/orderDetails/:orderId',
			name: 'orderDetails',
			component: () => import('./views/user/OrderDetails.vue')
		},
		{
			//未支付订单详情
			path: '/orderPay/:orderId',
			name: 'orderPay',
			component: () => import('./views/user/OrderPay.vue')
		},
		{
			//我的收货地址列表
			path: '/addressList',
			name: 'addressList',
			component: () => import('./views/user/AddressList.vue')
		},
		{
			//发起退款
			path: '/addrefund',
			name: 'addrefund',
			component: () => import('./views/user/Addrefund.vue')
		},
		{
			//退款列表
			path: '/refund',
			name: 'refund',
			component: () => import('./views/user/Refund.vue')
		},
		{
			//退款详情
			path: '/refundDetail/:id',
			name: 'refundDetail',
			component: () => import('./views/user/RefundDetail.vue')
		},
		{
			//编辑或新增我的收货地址
			path: '/addressSet/:addressId',
			name: 'addressSet',
			component: () => import('./views/user/AddressSet.vue')
		},
		{
			//我的会员卡列表
			path: '/cardList',
			name: 'cardList',
			component: () => import('./views/user/CardList.vue')
		},
		{
			//我的会员卡详情
			path: '/cardDetails/:shopId',
			name: 'cardDetails',
			component: () => import('./views/user/CardDetails.vue')
		},
		{
			//我的代金券
			path: '/cashCoupon',
			name: 'cashCoupon',
			component: () => import('./views/user/CashCoupon.vue')
		},



		{
			//商品详情
			path: '/goodsDetails/:goodsId',
			name: 'goodsDetails',
			component: () => import('./views/goods/GoodsDetails.vue')
		},
		{
			//商品订单
			path: '/goodsOrder/:goodsId/:cartId',
			name: 'goodsOrder',
			component: () => import('./views/goods/GoodsOrder.vue')
		},
		{
			//商品订单支付
			path: '/goodsOrderPay/:orderId',
			name: 'goodsOrderPay',
			component: () => import('./views/goods/GoodsOrderPay.vue')
		},
		{
			//商品订单支付
			path: '/goodsOrderOver',
			name: 'goodsOrderOver',
			component: () => import('./views/goods/GoodsOrderOver.vue')
		},
		{
			// 品牌专区
			path: '/brands',
			name: 'brands',
			component: () => import('./views/goods/brands.vue')
		},







		//-------------------














		{
			//线下兑换商品详情
			path: '/goodsDetailsX/:shopId/:goodsId',
			name: 'goodsDetailsX',
			component: () => import('./views/GoodsDetailsX.vue')
		},
		{
			//商品详情
			path: '/goodsInfo/:goodsId',
			name: 'goodsInfo',
			component: () => import('./views/GoodsInfo.vue')
		},
		{
			//商品分类
			path: '/goodsCategory',
			name: 'goodsCategory',
			component: () => import('./views/GoodsCategory.vue'),
			meta: {
				keepAlive: true, // 添加该字段，表示进入这个路由是需要登录的
			},
		},
		{
			// 特价商品分类
			path: '/tjgoodsCategory',
			name: 'tjgoodsCategory',
			component: () => import('./views/tjGoodsCategory.vue'),
			meta: {
				keepAlive: true, // 添加该字段，表示进入这个路由是需要登录的
			},
		},
		// {
		//     //商品订单
		//     path: '/goodsOrder/:param',
		//     name: 'goodsOrder',
		//     component: () => import('./views/GoodsOrder.vue')
		// },


		{
			//商家签合同
			path: '/shopContract/:shopId/:contractImg/:contractRet/:tel',
			name: 'shopContract',
			component: () => import('./views/ShopContract.vue')
		},

		{
			//业务员登录
			path: '/salesmanLogin',
			name: 'salesmanLogin',
			component: () => import('./views/SalesmanLogin.vue')
		},
		{
			//业务员注册
			path: '/salesmanRegister',
			name: 'salesmanRegister',
			component: () => import('./views/SalesmanRegister.vue')
		},
		{
			//业务员分享注册
			path: '/saleShareRegister',
			name: 'saleShareRegister',
			component: () => import('./views/salesman/SaleShareRegister.vue')
		},
		{
			//业务员分享注册记录
			path: '/shareRegisterUserList',
			name: 'shareRegisterUserList',
			component: () => import('./views/salesman/ShareRegisterUserList.vue')
		},
		{
			//业务员锁客提成记录
			path: '/shareRegisterUserListTC',
			name: 'shareRegisterUserListTC',
			component: () => import('./views/salesman/ShareRegisterUserListTC.vue')
		},
		{
			//业务员找回密码
			path: '/salesmanRetrievePass',
			name: 'salesmanRetrievePass',
			component: () => import('./views/SalesmanRetrievePass.vue')
		},
		{
			//业务员找回提现密码
			path: '/salesmanRetrievePayPass/:balance',
			name: 'salesmanRetrievePayPass',
			component: () => import('./views/SalesmanRetrievePayPass.vue')
		},
		{
			//业务员统计
			path: '/salesmanStatistics',
			name: 'salesmanStatistics',
			component: () => import('./views/SalesmanStatistics.vue')
		},
		{
			//业务员提现微信
			path: '/salesmanTX/:balance',
			name: 'salesmanTX',
			component: () => import('./views/SalesmanTX.vue')
		},
		{
			//业务员提现到支付宝
			path: '/salesmanTXByAlipay/:balance',
			name: 'salesmanTXByAlipay',
			component: () => import('./views/SalesmanTXByAlipay.vue')
		},
		{
			//业务员签署合同
			path: '/salesmanContract/:saleId',
			name: 'salesmanContract',
			component: () => import('./views/SalesmanContract.vue')
		},
		{
			//业务员个人中心
			path: '/salesmanInfo',
			name: 'salesmanInfo',
			component: () => import('./views/SalesmanInfo.vue'),
			meta: {},
		},
		{
			//业务员团队信息
			path: '/salesmanTeam',
			name: 'salesmanTeam',
			component: () => import('./views/SalesmanTeam.vue')
		},
		{
			//报备列表
			path: '/salesmanAllPrepareList',
			name: 'salesmanAllPrepareList',
			component: () => import('./views/SalesmanAllPrepareList.vue')
		},
		{
			//业务员添加报备商家
			path: '/salesmanAddPrepare',
			name: 'salesmanAddPrepare',
			component: () => import('./views/SalesmanAddPrepare.vue')
		},
		{
			//业务员自己的报备列表
			path: '/salesmanPrepareList',
			name: 'salesmanPrepareList',
			component: () => import('./views/SalesmanPrepareList.vue')
		},
		{
			//业务员报备列表详情
			path: '/salesmanPrepareDetails/:shopId/:stateSigning/:stateExamine',
			name: 'salesmanPrepareDetails',
			component: () => import('./views/SalesmanPrepareDetails.vue')
		},
		{
			//业务员提现记录
			path: '/salesmanCashList',
			name: 'salesmanCashList',
			component: () => import('./views/SalesmanCashList.vue')
		},
		{
			//业务员分成记录
			path: '/salesmanTCList',
			name: 'salesmanTCList',
			component: () => import('./views/SalesmanTCList.vue')
		},
		{
			//业务员签约商家记录
			path: '/salesmanShopRegister',
			name: 'salesmanShopRegister',
			component: () => import('./views/SalesmanShopRegister.vue')
		},
		{
			//查询业务员信息
			path: '/salesmanQuery',
			name: 'salesmanQuery',
			component: () => import('./views/SalesmanQuery.vue')
		},

		{
			//关于我们
			path: '/about',
			name: 'about',
			component: () => import('./views/About.vue')
		},
		{
			//按日期搜索
			path: '/searchByDate',
			name: 'searchByDate',
			component: () => import('./views/SearchByDate.vue')
		},
		{
			//咨询
			path: '/baseConsultation/:id',
			name: 'baseConsultation',
			component: () => import('./views/BaseConsultation.vue')
		},
		{
			//隐私条款
			path: '/privacy',
			name: 'privacy',
			component: () => import('./views/Privacy.vue')
		},
		{
			//注册时隐私条款
			path: '/appPrivacy',
			name: 'appPrivacy',
			component: () => import('./views/AppPrivacy.vue')
		},
		{	//视频列表
			path: '/videoList',
			name: 'videoList',
			component: () => import('./views/video/VideoList.vue'),
			meta: {
				keepAlive: true // 缓存
			},

		},
		{
			//视频播放
			path: '/videoPlay/:id',
			name: 'videoPlay',
			component: () => import('./views/video/VideoPlay.vue'),

		},
		{	//商家视频列表
			path: '/shopVideos',
			name: 'shopVideos',
			component: () => import('./views/video/ShopVideos.vue'),
			meta: {
				keepAlive: true // 缓存
			},

		},
		{
			//商家视频播放
			path: '/shopVideoPlay/:id/:distance',
			name: 'shopVideoPlay',
			component: () => import('./views/video/ShopVideoPlay.vue'),

		},
		{
			//新闻列表
			path: '/newsList',
			name: 'newsList',
			component: () => import('./views/temp/NewsList.vue')
		},
		{
			//新闻详情
			path: '/newsDetails/:id',
			name: 'newsDetails',
			component: () => import('./views/temp/NewsDetails.vue')
		},
		{
			//隐私政策
			path: '/yinsizhengce',
			name: 'yinsizhengce',
			component: () => import('./views/yinsizhengce.vue')
		},
		{
			//服务协议
			path: '/fuwuxieyi',
			name: 'fuwuxieyi',
			component: () => import('./views/fuwuxieyi.vue')
		},
		{
			//抽奖页面
			path: '/luck',
			name: 'luck',
			component: () => import('./views/newviews/luck.vue')
		},
		{
			//抽奖页面
			path: '/xmzx',
			name: 'xmzx',
			component: () => import('./views/newviews/xmzx.vue')
		},
		{
			//商家特色服务分类
			path: '/shopgoodscate',
			name: 'shopgoodscate',
			component: () => import('./views/newviews/shopgoodscate.vue')
		},
		{
			//商家特色服务分类对应的特殊服务
			path: '/shopgoods/:cateid',
			name: 'shopgoods',
			component: () => import('./views/newviews/shopgoods.vue')
		},
		{
			//商家特色服务订单
			path: '/shopgoodsorder',
			name: 'shopgoodsorder',
			component: () => import('./views/newviews/shopgoodsorder.vue')
		},
		{
			//商家特色服务订单
			path: '/newshopgoodsorder',
			name: 'newshopgoodsorder',
			component: () => import('./views/newviews/newshopgoodsorder.vue')
		},
		{
			//商家特色服务订单
			path: '/newshopgoodsorderdetail/:id',
			name: 'newshopgoodsorderdetail',
			component: () => import('./views/newviews/newshopgoodsorderdetail.vue')
		},
		{
			//商家特色服务订单
			path: '/memberpay',
			name: 'memberpay',
			component: () => import('./views/newviews/memberpay.vue')
		},
		{
			//扫码充值活动页-微信
			path: '/shopScanWx',
			name: 'shopScanWx',
			component: () => import('./views/ShopScanWx.vue')
		},
		{
			//扫码充值活动页-微信
			path: '/au',
			name: 'au',
			component: () => import('./views/Au.vue')
		},
		{
			//扫码充值活动页-支付宝
			path: '/shopScanZfb',
			name: 'shopScanZfb',
			component: () => import('./views/ShopScanZfb.vue')
		},
		{
			//扫码充值活动页-支付宝
			path: '/shareuserqrcode',
			name: 'shareuserqrcode',
			component: () => import('./views/shareuserqrcode.vue')
		},
		{
			//开发中界面
			path: '/development',
			name: 'development',
			component: () => import('./views/Development.vue')
		},
		{
			path: '/text',
			name: 'text',
			component: () => import('./views/Text.vue')
		},
		// 代理商模块
		{
			//商品集合
			path: '/Dl/goods/:typeId/:searchKey',
			name: 'dl/goods',
			component: () => import('./views/Dl/goods.vue'),
			// meta: {
			//     keepAlive: true // 缓存
			// }
		},
		// 限时抢购商品
		{
			//商品集合
			path: '/xs/goods/:typeId/:searchKey',
			name: 'xs/goods',
			component: () => import('./views/Xs/goods.vue'),
		},
		// 代理商模块
		{
			//成为代理
			path: '/Dl/register',
			name: 'dl/register',
			component: () => import('./views/Dl/register.vue'),
		},
		{
			//我的邀请码
			path: '/Dl/myqrcode',
			name: 'dl/myqrcode',
			component: () => import('./views/Dl/myqrcode.vue'),
		},
		{
			//下级代理
			path: '/Dl/dlusers',
			name: 'dl/dlusers',
			component: () => import('./views/Dl/dlusers.vue'),
		},
		{
			//代理提成
			path: '/Dl/tclist',
			name: 'dl/tclist',
			component: () => import('./views/Dl/tclist.vue'),
		},
		{
			path: '/*',
			name: 'error',
			component: () => import('./views/Error.vue')
		},

	]
})
